export const auxiliaryUtilsFunctions = () => {
    const handleHaveGenerics = (productGroups) => {
        return productGroups?.some(({ generics }) => generics && generics.length > 0);
    };

    return { handleHaveGenerics };
};
